import React, { useState, useEffect, useRef } from 'react';
import styles from './DressCode.module.css';
import dressIcon from '../../assets/boda.png';

const DressCode: React.FC = () => {
  const [isVisible, setIsVisible] = useState(false);
  const sectionRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          setIsVisible(true);
        }
      },
      {
        threshold: 0.2,
        rootMargin: '0px'
      }
    );

   const currentRef = sectionRef.current;

if (currentRef) {
  observer.observe(currentRef);
}

return () => {
  if (currentRef) {
    observer.unobserve(currentRef);
  }
};
  }, []);

  return (
    <section className={styles.dressCode} ref={sectionRef}>
      <div className={styles.topDecoration}></div>
      <div className="container">
        <h3 className={styles.sectionTitle}>Código de Vestimenta</h3>
        
        <div className={styles.dressCodeContent}>
          <div className={`${styles.dressCodeCard} ${isVisible ? styles.fadeIn : ''}`}>
            <div className={styles.dressIcon}>
              <img src={dressIcon} alt="Vestido elegante" />
            </div>
            <h4>Guapos y Elegantes</h4>
            <p className={styles.dressDescription}>
              Acompáñame luciendo tu mejor versión
            </p>
          </div>

          <div className={`${styles.reservedColorNotice} ${isVisible ? styles.fadeIn : ''}`}>
            
            <p className={styles.noticeText}>
              El color <span className={styles.pinkHighlight}>ROSA</span> en todas sus tonalidades<br />
              está reservado para la quinceañera
            </p>
            <div className={styles.colorSamples}>
              <div className={styles.colorDot} style={{backgroundColor: '#f5e6ea'}} title="Rosa pastel"></div>
              <div className={styles.colorDot} style={{backgroundColor: '#e6a3b3'}} title="Rosa claro"></div>
              <div className={styles.colorDot} style={{backgroundColor: '#d4899a'}} title="Rosa medio"></div>
              <div className={styles.colorDot} style={{backgroundColor: '#c47284'}} title="Rosa intenso"></div>
              <div className={styles.colorDot} style={{backgroundColor: '#b35b6f'}} title="Rosa profundo"></div>
            </div>
          </div>
        </div>

  
      </div>
    </section>
  );
};

export default DressCode;